<template lang="html">
  <div class="">


    <nav class="navbar navbar-inverse navbar-fixed-top">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>


            <!-- <img src="/static/logos/icjia1.png" height="25" style="margin-top: -2px; float: left"/> -->

            &nbsp;&nbsp;&nbsp;<span class="navbar-brand sidebar-toggle">
              <i class="fa fa-bars" aria-hidden="true"></i>
              <span class="nav-header">&nbsp;&nbsp;ICJIA Markdown Editor
            <!-- <span class="hidden-xs hidden-sm nav-sub-header">&nbsp;/ Boilerplate Generator</span> -->
          </span></span>
        </router-link>
        </div>


        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <!-- <li><a href="http://www.icjia.state.il.us" style="margin: 0; padding: 0"><img src="/static/logos/icjia1.png" height="22" style="margin-top: 15px;"/></a></li> -->

          </ul>

          <!-- <ul class="nav navbar-nav navbar-right" style="margin-right: 20px">



               <li><a href="" v-on:click.prevent="startTutorial" class="menu-item">TUTORIAL</a></li>
               <li>
                 <a href="https://github.com/ICJIA/icjia-markdown" class="menu-item"><i class="fa fa-github fa-1x" aria-hidden="true"></i></a></li>
                 <li><a href="http://www.icjia.state.il.us" style="margin: 0; padding: 0"><img src="/static/logos/icjia1.png" height="25" style="margin-top: 12px;"/></a></li>


          </ul> -->

          <ul class="nav navbar-nav navbar-right" style="margin-right: 20px">
            <li><a href="http://www.icjia.state.il.us/sandbox/typography" target="_blank" class="menu-item">ICJIA STYLE GUIDE&nbsp;&nbsp;<i class="fa fa-external-link" aria-hidden="true"></i></a></li>
           <li class="dropdown">
             <a href="#" class="dropdown-toggle menu-item"  data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Examples <span class="caret"></span></a>
             <ul class="dropdown-menu" >
               <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('ICJIA Style Guide')">ICJIA Style Guide</a></li>
                <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('What is Markdown?')">What is Markdown?</a></li>
                 <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Getting Started')">Getting Started</a></li>
               <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Tables')">Tables</a></li>
                <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Math (using KaTeX)')">Math (using KaTeX)</a></li>
                  <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Fontawesome icons')">Fontawesome icons</a></li>
                  <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Footnotes')">Footnotes</a></li>
                  <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('GitHub README')">GitHub README</a></li>
                  <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Images')">Images</a></li>
                  <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Return to page top')">Return to page top</a></li>
                    <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Mixed HTML and Markdown')">Mixed HTML and Markdown</a></li>
                      <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Expandable details')">Expandable details</a></li>

             </ul>
           </li>
           <li class="dropdown">
             <a href="#" class="dropdown-toggle menu-item" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Boilerplate <span class="caret"></span></a>
             <ul class="dropdown-menu">

               <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Privacy 01')">ICJIA Privacy Policy</a></li>
               <li><a href="#" v-on:click.stop.prevent="loadBoilerplateEvent('Article 01')">ICJIA Article 01</a></li>
             </ul>
           </li>
           <!-- <li><a href="" v-on:click.prevent="startTutorial" class="menu-item">TUTORIAL</a></li> -->

           <li><a href="http://www.icjia.state.il.us" style="margin: 0; padding: 0"><img src="/static/logos/icjia1.png" height="20" style="margin-top: 16px; margin-left: 12px;"/></a></li>
         </ul>


        </div><!-- /.navbar-collapse -->
      </div><!-- /.container-fluid -->
    </nav>
  </div>
</template>

<script>

/* https://alligator.io/vuejs/global-event-bus/ */
import { EventBus } from '@/event-bus';

export default {

  mounted: function () {

    $(".sidebar-toggle").click(function(e) {
      e.preventDefault();
      $("#wrapper").toggleClass("toggled");
    });

            $('a.icjiaTypography').webuiPopover({width: 900, height: 500, type:'iframe',url:'http://www.icjia.state.il.us/sandbox/typography'});

    $(document).ready(function () {
      $(".dropdown-menu a").click(function() {
        $(this).closest(".dropdown-menu").prev().dropdown("toggle");
      });
    })


  },

  methods: {

    loadBoilerplateEvent(bp) {
      EventBus.$emit('load-boilerplate', bp);
    },

      startTutorial: function () {
        introJs().start();
      }
    }
}
</script>

<style lang="css" scoped>

.sidebar-toggle {color: #fff !important}
.sidebar-toggle:hover {color: #ccc !important; cursor: pointer !important}

</style>



// WEBPACK FOOTER //
// Navbar.vue?6743e90a